import Vue from 'vue'
import App from './App.vue'
import VModal from 'vue-js-modal'
import Notifications from 'vue-notification'

Vue.use(VModal)
Vue.use(Notifications)

import { store } from './store/index'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  store
}).$mount('#app')
